import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';

import { ViewOrderButtonDesktop } from '@views/Payments/ViewOrderButton';
import { CarImage } from '@views/Payments/CarImage';
import { getFeatures } from '@utils';
import { formatPriceWithCents } from '@utils/currency';
import { formatDateWithLocale } from '@utils/dateFormatter';
import { getLocalizedContent as l } from '@helpers/languages';
import content from './DesktopOrderSummary.json';
const useStyles = makeStyles(() => ({
  orderSummaryWrapper: {
    padding: '131px 32px',
    backgroundColor: '#e4dfd4',
  },
  orderSummaryTitle: {
    fontFamily: 'SchnyderSLight',
    fontSize: '40px',
  },
  orderSummaryCarName: {
    fontSize: '20px',
    paddingBottom: '8px',
    color: '#1b1b1b',
  },
  orderNumber: {
    fontSize: '20px',
    paddingTop: '8px',
    color: '#1b1b1b',
  },
  orderSummaryText: {
    fontSize: '16px',
    color: '#1b1b1b',
    lineHeight: '24px',
  },
  carImage: {
    padding: '12px 0',
  },
  viewOrderButton: {
    padding: '48px 0',
  },
}));

export const DesktopOrderSummary = ({
  order,
  total,
  language,
  hasValidOrderReceipt,
}) => {
  const classes = useStyles();

  const orderTotalAndDate = () => {
    const formattedOrderDate = formatDateWithLocale(
      order.order.orderCreated,
      language
    );
    const formattedTotal = formatPriceWithCents(total.amount, total.currency);
    return `${formattedTotal} / ${formattedOrderDate}`;
  };

  return (
    <Box className={classes.orderSummaryWrapper}>
      <Typography variant="h4" className={classes.orderSummaryTitle}>
        {l(content.orderSummary, language)}
      </Typography>
      {order && (
        <>
          <Typography variant="h5" className={classes.orderNumber}>
            {l(content.orderNum, language)}
            {order.order.orderId}
          </Typography>
          <div className={classes.carImage}>
            <CarImage shortcode={order.shortcode} />
          </div>
          <Typography variant="h5" className={classes.orderSummaryCarName}>
            {order.configName}
          </Typography>
          <Typography variant="body2" className={classes.orderSummaryText}>
            {order.trim}
          </Typography>
          <Typography variant="body2" className={classes.orderSummaryText}>
            {orderTotalAndDate()}
          </Typography>
          <br />
          <Typography variant="body2" className={classes.orderSummaryText}>
            {getFeatures(order.metadata, order.trim)}
          </Typography>
          {hasValidOrderReceipt && (
            <div className={classes.viewOrderButton}>
              <ViewOrderButtonDesktop orderId={order.order.orderId} />
            </div>
          )}
        </>
      )}
    </Box>
  );
};
